import React from 'react';
import { Formik, Form, Field } from 'formik';
import { Path } from 'history';
import { Button } from '../../../components/Button';
import { Field as FromField } from '../../../../../components/forms/Field';

import {
  createChannelSchema,
  validateUserIDsSet
} from '../../../validators/createChannelSchema';
import { Input, Select, TextArea } from '../../../../../components/forms';
import { FormFooter } from '../CreateChannel.styles';
import { Search } from '../../Search';
import { UserList } from '../../../components/UserList';
import {
  FormValues,
  OnUserRemoveFunc,
  OnUserSelectFunc,
  UserType
} from '../../../types';

const countryOptions = [
  { key: 'prv', value: 'private', text: 'Private' },
  { key: 'pbl', value: 'public', text: 'Public' }
];

interface CreateChannelFormProps {
  onUserSelect: OnUserSelectFunc;
  onRemove: OnUserRemoveFunc;
  createChannel: (values: object, callBack?: (path: Path, state?: {}) => void) => void;
  usersData: UserType[] | [];
  userIDs: string[];
  push: (path: Path, state?: {}) => void;
}

const form = {
  reset: null,
  setErrors: null
};

const CreateChannelForm: React.FC<CreateChannelFormProps> = ({
  createChannel,
  userIDs,
  usersData,
  onUserSelect,
  onRemove,
  push
}) => {
  const initialValues: FormValues = {
    name: '',
    privacy: '',
    content: '',
    invitedPeople: null
  };
  const handleSubmit = ({ name, privacy, content }, actions): void => {
    const isInvited = validateUserIDsSet(userIDs);

    if (isInvited) {
      form.setErrors({
        invitedPeople: isInvited
      });
      actions.setSubmitting(false);
      return;
    }

    createChannel({
      name,
      content,
      users: userIDs,
      type: privacy === 'private'
    }, push);
    actions.setSubmitting(false);
  };

  const selectedUsers = usersData.filter(({ userId }) => userIDs.includes(userId));

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={createChannelSchema}
      onSubmit={handleSubmit}
      render={({ isSubmitting, resetForm, setErrors, errors }) => {
        form.reset = resetForm;
        form.setErrors = setErrors;

        return (
          <div>
            <Form>
              <div className="form-wrapper">
                <div className="first-row">
                  <Field
                    key="name"
                    name="name"
                    render={formProps => (
                      <Input
                        placeholder="Please Enter the Name of Channel"
                        type="text"
                        labelText="Name of Channel"
                        disabled={isSubmitting}
                        {...formProps}
                      />
                    )}
                  />
                  <Field
                    key="privacy"
                    name="privacy"
                    render={formProps => (
                      <Select
                        placeholder="Please select Privacy"
                        labelText="Privacy"
                        disabled={isSubmitting}
                        options={countryOptions}
                        {...formProps}
                      />
                    )}
                  />
                </div>
                <hr />
                <div className="second-row">
                  <Field
                    key="content"
                    name="content"
                    render={formProps => (
                      <div className="text-area">
                        <TextArea
                          minHeight={110}
                          placeholder=""
                          disabled={isSubmitting}
                          labelText="Details"
                          {...formProps}
                        />
                      </div>
                    )}
                  />
                </div>

                <hr />
                <div className="third-row">
                  <FromField
                    labelText="Invite people"
                    error={errors.invitedPeople}
                  >
                    <Search
                      onUserSelect={onUserSelect}
                      listUsers={usersData}
                      items={selectedUsers}
                    />
                  </FromField>
                  <FromField labelText="Invited people">
                    {usersData && (
                      <UserList items={selectedUsers} onRemove={onRemove} />
                    )}
                  </FromField>
                </div>
              </div>
              <hr />

              <FormFooter>
                <Button type="submit" primary>
                  Create
                </Button>
              </FormFooter>
            </Form>
          </div>
        );
      }}
    />
  );
};
export default CreateChannelForm;
